/**
 * Planner Service - Handles API interactions for Planners
 */

import axios from 'axios';

import { post, put, get } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
// const API_URL = `/api/v1/mms_persistence/ai_models`;
const PLANNER_URL = `/api/v1/mms_ai_configs/planner/config/`
const GET_GENERIC_URL = `/api/v1/mms_ai_metric_events/metrics/runs/configs_with_aggregate_metrics/`
const API_URL = `/api/v1/mms_persistence/planners`;

/**
 * Get all Planners with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of planners
 */
export const getPlanners = async (filter = {}, sort = {}, query = {}) => {
  try {
    const { skip, limit } = query;
    const response = await post(`${PLANNER_URL}fetch`, { filter, sort, skip, limit });
    return response;
  } catch (error) {
    console.error('Error fetching planners:', error);
    throw error;
  }
};

export const getPlannersPaginated = async (filter = {}, sort = {}, query = {}) => {
  try {
    const { skip, limit } = query;
    const response = await post(`${GET_GENERIC_URL}planner`, { filter, sort, skip, limit });
    return response;
  } catch (error) {
    console.error('Error fetching planners:', error);
    throw error;
  }
};

export const getPlannersConfig = async (filter = {}, sort = {}, query = {}) => {
  try {
    const { skip, limit } = query;
    const response = await post(`${PLANNER_URL}fetch`, { filter, sort, skip, limit });
    return response;
  } catch (error) {
    console.error('Error fetching planners:', error);
    throw error;
  }
};

/**
 * Get planner count
 * @returns {Promise<Array>} List of agent tasks
 */
export const getPlannersCount = async (filter) => {
  try {
    const response = await post(`${PLANNER_URL}count`, { filter });
    return response;
  } catch (error) {
    console.error('Error fetching planner count:', error);
    throw error;
  }
};


/*
 * Get planner with model code
 * @param {code} - planner code
 * @returns {Promise<Array>} Promise resolving to array of models
 */
export const getPlannerByCode = async (plannerCode) => {
  try {
    const response = await get(`${PLANNER_URL}get_by_cd/${plannerCode}`);
    return response;
  } catch (error) {
    console.error('Error fetching planner:', error);
    throw error;
  }
};



/**
 * Create a new planner
 * @param {Object} plannerData - Model data
 * @returns {Promise<Object>} Promise resolving to created model
 */
export const createPlanner = async (plannerData) => {
  try {
    const response = await post(`${PLANNER_URL}`, plannerData);
    return response;
  } catch (error) {
    console.error('Error creating planner:', error);
    throw error;
  }
};

/**
 * Update an existing planner
 * @param {string} plannerId - planner ID
 * @param {Object} plannerData - Updated planner data
 * @returns {Promise<Object>} Promise resolving to updated model
 */
export const updatePlanner = async (plannerData) => {
  try {
    const response = await put(`${PLANNER_URL}`, plannerData);
    return response;
  } catch (error) {
    console.error(`Error updating planner :`, error);
    throw error;
  }
};